import React from 'react';
import Reports from './Reports';
import Layout from '../common/Layout';
import reportService from '../../services/reportService';

export default function () {
    return <Layout>
        <Reports reportService={reportService} />
    </Layout>
};